module.exports = __webpack_public_path__ + "ca302abbb2fae3d34e9611ab8fb2c1a5.svg";